import { Box, Typography } from "@mui/material";

const ProjectsPlanner = () => (
  <Box>
    <Typography variant={"h2"}>ProjectsPlanner</Typography>
    <Typography variant={"body1"}>ProjectsPlanner body copy here</Typography>
  </Box>
);

export default ProjectsPlanner;
